import { Component, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';

import { BreadcrumbService } from '../../domain/services/breadcrumb/breadcrumb.service';
import {
  DashboardService,
  DashboardStats,
  RecentTask,
  ActivityItem
} from '../../domain/services/dashboard/dashboard.service';
import { StatusIndicatorComponent } from '../../common/status-indicator/status-indicator.component';

interface KpiCard {
  label: string;
  value: number;
  icon: string;
  iconColor: string;
  iconBg: string;
  routerLink?: string;
}

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    DatePipe,
    RouterModule,
    MatCardModule,
    MatIconModule,
    MatTableModule,
    MatButtonModule,
    StatusIndicatorComponent
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent implements OnInit {
  stats: DashboardStats | null = null;
  recentTasks: RecentTask[] = [];
  recentActivity: ActivityItem[] = [];

  kpiCards: KpiCard[] = [];

  taskDisplayedColumns = ['id', 'type', 'dateReceived', 'status'];

  constructor(
    private readonly breadcrumbService: BreadcrumbService,
    private readonly dashboardService: DashboardService
  ) {}

  ngOnInit(): void {
    this.breadcrumbService.updateBreadcrumbs([
      {
        icon: 'dashboard',
        url: '/app/dashboard',
        label: 'Dashboard'
      }
    ]);

    this.dashboardService.getDashboardStats().subscribe(stats => {
      this.stats = stats;
      this.buildKpiCards(stats);
    });

    this.dashboardService.getRecentTasks().subscribe(tasks => {
      this.recentTasks = tasks;
    });

    this.dashboardService.getRecentActivity().subscribe(activity => {
      this.recentActivity = activity;
    });
  }

  private buildKpiCards(stats: DashboardStats): void {
    this.kpiCards = [
      {
        label: 'Open Tasks',
        value: stats.openTasks,
        icon: 'fact_check',
        iconColor: '#2563eb',
        iconBg: '#eff6ff',
        routerLink: '/app/tasks'
      },
      {
        label: 'Active Accounts',
        value: stats.activeAccounts,
        icon: 'business',
        iconColor: '#16a34a',
        iconBg: '#f0fdf4',
        routerLink: '/app/search/customer'
      },
      {
        label: 'Properties Registered',
        value: stats.totalProperties,
        icon: 'home_work',
        iconColor: '#7c3aed',
        iconBg: '#f5f3ff',
        routerLink: '/app/search/property'
      },
      {
        label: 'Pending Enrollments',
        value: stats.pendingEnrollments,
        icon: 'how_to_reg',
        iconColor: '#d97706',
        iconBg: '#fffbeb'
      }
    ];
  }
}
